import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function InvalidParameterFormatDialog({ handleClose }) {
  return (
    <Dialog
      title={"Invalid CSV Format"}
      onClose={handleClose}
    >
      <div style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        <p style={{ marginBottom: "15px", color: "var(--atlas-text-primary)" }}>
          The CSV file format is invalid for Global Parameters datasets.
        </p>
        <div
          style={{
            border: "1px solid var(--atlas-border-color)",
            padding: "15px",
            margin: "15px 0",
            backgroundColor: "var(--atlas-bg-secondary)",
            borderRadius: "4px",
            color: "var(--atlas-text-primary)",
            textAlign: "left",
          }}
        >
          <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
            Expected format (one or two columns):
          </p>
          <code
            style={{ display: "block", marginBottom: "5px", color: "var(--atlas-text-secondary)" }}
          >
            Parameter Name,Parameter Value
          </code>
          <code
            style={{ display: "block", marginBottom: "10px", color: "var(--atlas-text-secondary)" }}
          >
            &quot;value1&quot;,&quot;parametervalue1&quot;
          </code>
          <p style={{ marginBottom: "5px", fontWeight: "bold" }}>Or single column:</p>
          <code
            style={{ display: "block", marginBottom: "5px", color: "var(--atlas-text-secondary)" }}
          >
            Parameter Name
          </code>
          <code style={{ display: "block", color: "var(--atlas-text-secondary)" }}>
            &quot;value1&quot;
          </code>
        </div>
        <p style={{ marginTop: "15px", color: Colors.error, fontWeight: "bold" }}>
          Import aborted. Please ensure the CSV has a valid header row.
        </p>
      </div>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnInvalidParameterFormatClose`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default InvalidParameterFormatDialog;

